import type { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'

class RegisterComponent extends BaseComponent {
  formAttribute: string
  form: Nullable<HTMLElement>

  constructor() {
    super()

    this.formAttribute = '[data-register-form]'

    this.form = this.querySelector(this.formAttribute)
  }

  connectedCallback(): void {
    this.form?.addEventListener('submit', this.handleSubmit)
  }

  disconnectedCallback(): void {
    this.form?.removeEventListener('submit', this.handleSubmit)
  }

  handleSubmit(): void {
    localStorage.setItem('isRegistered', 'true')
  }
}

export default RegisterComponent
